import { render, staticRenderFns } from "./BaseUpload.vue?vue&type=template&id=13ec6696&"
import script from "./BaseUpload.vue?vue&type=script&lang=js&"
export * from "./BaseUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ec6696')) {
      api.createRecord('13ec6696', component.options)
    } else {
      api.reload('13ec6696', component.options)
    }
    module.hot.accept("./BaseUpload.vue?vue&type=template&id=13ec6696&", function () {
      api.rerender('13ec6696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseUpload.vue"
export default component.exports